import type { DisciplineInfo } from '@brighterly/lib-core-types/discipline/interfaces'

import { useCommonStore } from '@stores/common'
import { useDisciplineStore } from '@stores/discipline'

import { useCsRoutes } from '@composables/routes/cs-route.hook'

interface ActiveDisciplineInfoApiOptions {
  onStart?: () => void
  onSuccess?: (disciplineInfo: any) => void
  onError?: (err: any) => void
  onFinish?: () => void
}

let currentRequest: Promise<DisciplineInfo | null> | null = null
let lastCompletedAt = 0
const DEDUP_WINDOW_MS = 500

export const useActiveDisciplineInfoApi = async (options?: ActiveDisciplineInfoApiOptions): Promise<DisciplineInfo | null> => {
  if (currentRequest) return currentRequest

  if (Date.now() - lastCompletedAt < DEDUP_WINDOW_MS) return null

  const { $axios } = useNuxtApp()

  const commonStore = useCommonStore()
  const disciplineStore = useDisciplineStore()

  const discipline = disciplineStore.activeDiscipline!

  const url = useCsRoutes('discipline', {
    '[discipline_id]': discipline.id,
  })

  options?.onStart?.()
  commonStore.setLoading(true)

  currentRequest = $axios.get(url!)
    .then(({ data }) => {
      const disciplineInfo = data.data || []

      commonStore.setLoading(false)
      options?.onSuccess?.(disciplineInfo)

      disciplineStore.setDisciplineInfo(disciplineInfo, discipline.code)

      return disciplineInfo as DisciplineInfo
    })
    .catch((err) => {
      console.error(err)
      options?.onError?.(err)

      return null
    })
    .finally(() => {
      options?.onFinish?.()
      lastCompletedAt = Date.now()
      currentRequest = null
    })

  return currentRequest
}
